import * as React from 'react'
import { OrderElement } from '../order_types'

type StockLevelWarningProps = {
  elements: OrderElement[]
}

function StockLevelWarning ({ elements }: StockLevelWarningProps) {
  const { I18n } = window as any
  const elementsArray = Object.values(elements || {})
  if (elementsArray.length === 0) {
    return null
  }
  const stockLevelBelowZero = elementsArray.some(el => el.template?.stock_level < 0)
  if (stockLevelBelowZero) {
    return (
      <div className="stock-level-warning alert alert-warning">
        {I18n.t('elements.order_form.stock_level_warning')}
      </div>
    )
  }
  return null
}

export default StockLevelWarning
